import React from 'react';
import { SUPPORT_EMAIL } from 'utils';
import { Text, Link } from 'components';
import { StyledBodyPane } from './StyledComponents';

const AnsweringServiceError: React.FC = () => (
  <StyledBodyPane>
    <Text>
      It looks like something went wrong connecting you to the Answering Service
      screen. Please contact our Customer Success team at{' '}
      <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link> with your
      brokerage information.
    </Text>
  </StyledBodyPane>
);

export default AnsweringServiceError;
